import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import HorizontalSeparator from "../../components/common/HorizontalSeparator";
import TitleSubtitle from "../../components/common/TitleSubtitle";
import { MapInitializer } from "../../utils/mapInitializer";
import "leaflet/dist/leaflet.css";
import "leaflet-geometryutil";
import { MapContainer, TileLayer } from "react-leaflet";
import L from "leaflet";
import mapStyles from "../track/create/createMap.module.css";

const MapStudio: React.FC = () => {
    const { t: rawT } = useTranslation();
    const [, setMap] = useState<L.Map | null>(null);
    const t = rawT as any;

    const handleMapReady = (mapInstance: L.Map) => {
        setMap(mapInstance);
    };

    return (
        <div className="text-creation-page">
            <TitleSubtitle title={t("mapStudio")} subtitle={t("mapStudioSubtitle")} shouldIncludeMarginStart={true} />
            <HorizontalSeparator />

            <div className={mapStyles.mapStudioContainer}>
                <div className="map-placeholder">
                    <MapContainer
                        center={[1, 1]}
                        zoom={16}
                        style={{ height: "500px", width: "100%" }}
                        scrollWheelZoom={false}
                        doubleClickZoom={false}
                    >
                        <MapInitializer onMapReady={handleMapReady} />
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        />
                    </MapContainer>
                </div>
            </div>
        </div>
    );
};

export default MapStudio;
